import apiClient from '@/apis/client';
import { PlanType } from '@/types/plan';
import { ReportStatus, Session, VisaType } from '@/types/report';

export interface ResponseListReports {
  data: {
    id: string;
    targetDestination: string;
    citizenship: string;
    visaType: VisaType;
    userId: string;
    language: string;
    createdAt: Date;
    familyMembers?: string;
    familyMembersCitizenship?: string;
    pet?: string;
    professionQuestion?: string;
    planType: PlanType;
    sessions: Session[];
    updatedAt: Date;
    status: ReportStatus;
  }[];
  total: number;
}

export default async function listReportsApi(
  token: string
): Promise<ResponseListReports> {
  return apiClient.get<ResponseListReports>('/report', { token });
}
